module.exports = __webpack_public_path__ + "img/RABaseBG.1431ec59.jpeg";